import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {IExgEvent} from '../../misc/interfaces/IExgEvent';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {ExgDataListComponent} from 'exc-controls-v2';
import {ExgFilterComponent} from '../../misc/exg-filter/exg-filter.component';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styles: []
})
export class UserListComponent extends ExcTranslation implements IExgEvent, OnInit, AfterViewInit {
  @ViewChild('VCUserTable', {read: ExgDataListComponent}) VCUserTable!: ExgDataListComponent;
  @ViewChild('VCUserTableFilterControl', {read: ExgFilterComponent}) VCUserTableFilterControl!: ExgFilterComponent;
  init = true;
  currentdate = new Date();
  oneJan = new Date(this.currentdate.getFullYear(),0,1);
  numberOfDays = Math.floor(((this.currentdate as any) - (this.oneJan as any)) / (24 * 60 * 60 * 1000));
  KW = Math.ceil(( this.currentdate.getDay() + 1 + this.numberOfDays) / 7);
  /* Left List of users */
  // data
  userTable = {
    data: [] as any,
    uiFilter: [] as any[],
    uiSort: [] as any[],
    uiFilterEnumGroup: [
      {enmName: 'CrmRollePerson', enmField: 'oe_CrmRolle', enmTable: 'OE', defaultValues: [6]},
    ],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0,
      pagingEndRow: 0,
      pagingPageSize: 25,
      pagingTotalPages: 0,
      pagingTotalRows: 0,
      pagingStartRow: 0,
    },
    isLoading: true,
  };
  // config
  config = {
    userTable: {
      selectKey: 'oeID',
      state: 1,
      selectedRow: undefined as any,
      searchValue: '',
      ready: () => {
        if (!this.userTable.data || this.userTable.data.length === 0) {
          this.config.userTable.state = 2;
          this.VCUserTable.selectedRow = -1;
        } else {
          this.config.userTable.state = 0;
          this.VCUserTable.selectedRow = 0;
        }
        this.init = false;
      },
      selectionChanged: (index: number) => {
        this.config.userTable.selectedRow = this.userTable.data[index];
      },
      pageChanged: (page: number) => {
        if (this.userTable.MetaInfo.dataPaging !== undefined) {
          this.userTable.MetaInfo.dataPaging.pageNo = page;
        }
        this.config.userTable.loadData();
      },
      search: (value: string) => {
        this.config.userTable.searchValue = value;
        this.config.userTable.pageChanged(1);
      },
      loadData: () => {
        const SELF = this;
        SELF.config.userTable.state = 1;
        SELF.userTable.isLoading = true;
        SELF.excRest
          .sget(
            SELF.excRest.computeUrl('OeR_List_User', {
              fts: this.config?.userTable?.searchValue,
            }),
            'userList',
            {MetaInfo: SELF.userTable.MetaInfo}
          )
          .subscribe((response) => {
            if (response.success && response.data) {
              SELF.userTable.data = response.data;
              SELF.userTable.paging = response.paging;
            } else {
              SELF.userTable.data = [];
              SELF.userTable.paging = {
                pagingPage: 0,
                pagingEndRow: 0,
                pagingPageSize: 25,
                pagingTotalPages: 0,
                pagingTotalRows: 0,
                pagingStartRow: 0,
              };
            }
            SELF.config.userTable.ready();
            SELF.userTable.isLoading = false;
          });
      }
    }
  };

  Events: ExgApplicationEventEmitter = new ExgApplicationEventEmitter();

  constructor(
    private excRest: ExcRestService,
    public appSvc: ApplicationService,
    public enumSvc: EnumerationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initEnumerations();
  }

  ngAfterViewInit(): void {
    this.VCUserTableFilterControl.ApplyFilter();
  }

  initEnumerations(): void {
    this.userTable.uiFilter =
      this.appSvc.metaInfo.dataFilter(
        this.userTable.uiFilterEnumGroup
        , []);
  }

  getUsrTyp(inputValue: any): string {
    const value = Number(inputValue);
    if (value === 1) {
      return 'EIS-Mitarbeiter';
    } else if (value === 2) {
      return 'Sachverständiger';
    } else if (value === 3) {
      return 'Mandate';
    }
    return '';
  }
}
